/** @jsxImportSource @emotion/react */
import { Field } from 'formik'

export interface FormValues {
  id?: string
  name: string
  shortName: string
  cptCode: string
  description: string
  charge: number | undefined
}

const BillingProceduresForm = () => {

  return (
    <>
      <div className="form-row">
        <div className="col form-group">
          <label htmlFor="cptCode">
            CPT Code
            <span className="text-danger">*</span>
          </label>
          <Field
            type="text"
            name="cptCode"
            className="form-control"
            placeholder="CPT Code"
          />
        </div>

        <div className="col form-group">
          <label htmlFor="name">
            Name
            <span className="text-danger">*</span>
          </label>
          <Field
            type="text"
            name="name"
            required
            className="form-control"
            placeholder="Name"
          />
        </div>

        <div className="col form-group">
          <label htmlFor="shortName">
            Short Name
          </label>
          <Field
            type="text"
            name="shortName"
            className="form-control"
            placeholder="Short Name"
          />
        </div>

        <div className="col form-group">
          <label htmlFor="charge">
            Flat Charge
            <span className="text-danger">*</span>
          </label>
          <Field
            type="number"
            name="charge"
            required
            className="form-control"
            placeholder="$0.00"
          />
        </div>
      </div>

      <div className="form-row">
        <div className="col form-group">
          <label htmlFor="description">
            Description
          </label>
          <Field
            css={{height: '4rem!important'}}
            rows="2"
            type="textarea"
            as="textarea"
            name="description"
            className="form-control"
            placeholder="Description"
          />
        </div>
      </div>
    </>
  )
}

export default BillingProceduresForm
